import React from "react";

const SectionHead = ({ subtitle, title }) => {
    return (
        <>
            <div className="section-head">
                <h3
                    data-aos="fade-up"
                    data-aos-duration="300"
                    data-aos-delay="200"
                >
                    {title}
                </h3>
            </div>
        </>
    );
};

export default SectionHead;
